import { render, staticRenderFns } from "./JieLongList.vue?vue&type=template&id=126caf0a&scoped=true"
import script from "./JieLongList.vue?vue&type=script&lang=ts"
export * from "./JieLongList.vue?vue&type=script&lang=ts"
import style0 from "./JieLongList.vue?vue&type=style&index=0&id=126caf0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126caf0a",
  null
  
)

export default component.exports